import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { base } from 'wagmi/chains';

export const config = getDefaultConfig({
  appName: 'GuiltBox',
  projectId: process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || 'd85f4982ce53dc86e64302cb45038f90',
  chains: [base], // Only Base Mainnet
  ssr: false, // we're not using server side rendering
  appDescription: 'Transform your confession into crypto tokens for charity',
  appUrl: typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000',
  appIcon: typeof window !== 'undefined' ? `${window.location.origin}/favicon.ico` : 'http://localhost:3000/favicon.ico'
});